import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import cover from "../../../images/about-me-cover.png";
import "./About.css";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div id="about" className="about-bg">
      <Container fluid>
        <Row>
          <Col sm={12} md={6}>
            <img
              className="about-cover"
              data-aos="flip-left"
              src={cover}
              alt=""
            />
          </Col>
          <Col sm={12} md={6}>
            <div className="about-text">
              <h2>About Me</h2>
              <p>
                I've always had a strong interest in web development, and as a
                result, I've recently learned several critical Front-end
                development technologies, such as HTML, CSS, JavaScript, and
                M.E.R.N. It's so fascinating that it motivates me to expand my
                knowledge and proficiency in these technology areas. I am keen
                to work in the web technology field to hone my abilities,
                increase efficiency, and get experience to benefit my future
                career.
              </p>
              <Link to="/about-me">
                <button className="bk-button">Read More</button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
